let cartItems;
     var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'INR',
});
////////////////////////////// Cart icons click //////////////////////////////////
$('.ajaxCart').each(function(ind,el){
  $(el).on('click',function(e){
  	e.preventDefault();
    	jQuery.getJSON('/cart.js', function(cart) {
		cartItems = cart.items;
        }).then(resp=>{
        	displayCart();  
          
        });
  })
})
const updateCartCount = function(count){
  $('.cartCount').each(function(ind,el){
  	$(el)[0].textContent = count;
  })
}
//////////////////////////////// displaying cart logic \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
$('.close_cart').each(function(ind,el){
  $(el).on('click',function(){
  	closeCart();
  })
})
$('.ajax-cart-overlay').on('click',function(){
	closeCart();
})
const displayCart = function(){
	$('.ajax-cart-modal')[0].style.right = "0px";	
	displayOverlay();
}
const closeCart = function(){
	$('.ajax-cart-modal')[0].style.right = "-120%";
  hideOverlay();
}
const displayOverlay = function(){
	$('.ajax-cart-overlay')[0].style.display = "block";
  setTimeout(function(){
  	$('.ajax-cart-overlay')[0].style.opacity = "1";
  },0)
}
const hideOverlay = function(){
	$('.ajax-cart-overlay')[0].style.opacity = "0";
  setTimeout(function(){
  	$('.ajax-cart-overlay')[0].style.display = "none";
  },300)
}
///////////////////////////////////cart display ends \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
////////////////////innner cart item \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
$('.inc').each(function(ind,el){
  $(el).on('click',function(e){
    e.preventDefault();
  	let form = $(this).closest('form');
     let prodId = form[0].id;
    let inp = $(form).children('input[type="number"]');
    let max = Number(inp[0].max);
    console.log(max);
    let inputval = Number(inp[0].value);
    if(inputval < max){
    	 inputval++;
    }else{
    	return false;
    }
   
    inp[0].value = inputval;
    updateCart(prodId,inputval);
  })
})
$('.dec').each(function(ind,el){
  $(el).on('click',function(e){
    e.preventDefault();
  	let form = $(this).closest('form');
     let prodId = form[0].id;
    let inp = $(form).children('input[type="number"]');
    let min = Number(inp[0].min);
    let inputval = Number(inp[0].value);
    if(inputval > min){

    	inputval--;	
      inp[0].value = inputval;
    updateCart(prodId,inputval);
    }else if(inputval === min){
	updateCartDis(prodId,0);
    }
  })
})
////////////////////// Change totla amount \\\\\\\\\\\\\\\\\\\\\\\\\\\
const totalAmount = function(){
	$('.total_amount')[0].textContent = ' ';
     $('.total_amount')[0].textContent = formatter.format(cartTotal);
}
///////////////////////////////////////// Ajax cart ////////////////////////////////////////////////
let qn = 1;
let pId;
let formData = {
  items:[]
};

let addToCartBtn = $('.addToCart');
$(document).on('click',function(evt){
  if(evt.target.classList.contains('addToCart')){
    console.log(this);
    evt.preventDefault();
  	let el = evt.target;
  	let form = $(el).closest('form');
    let quantityInput = $(form).find('.quantity__input');
    if(quantityInput[0]){
    	qn=Number(quantityInput[0].value);

    }else{
    	qn=1;
    }
    pId = Number(form[0].dataset.id);
    let productData = {};
    productData.id = pId;
    productData.quantity = qn;
    formData.items.push(productData);
    jQuery.getJSON('/cart.js', function(cart) {
		cartItems = cart.items;
    }).then(repsonse =>{
      if(!cartItems.find(i => i.id === pId)){
      	addToCart(productData);
      }else{
        let productQn = cartItems.find(i => i.id === pId).quantity;
        if(quantityInput){
        	productQn+= qn;
        }else{
        	productQn++;	
        }
        updateCartDis(pId,productQn);
      }
    })
 }else{
  	console.log('nope');
  }
})

$('.clr_item').each(function(ind,el){	
  $(el).on('click',function(e){
    e.preventDefault();
  		let form = $(this).closest('form');
     let prodId = form[0].id;
    updateCartDis(prodId,0);
  })
})


//////////////////////////////////////// for adding products //////////////////////////////////////
const addToCart = function(data){
	 fetch('/cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(data)
})
.then(response => {
   jQuery.getJSON('/cart.js', function(cart) {
	cartItems = cart.items;
     let cartTotal = cart.total_price/100;
     let cartCount = cart.item_count;
     updateCartCount(cartCount);
     $('.total_amount')[0].textContent = ' ';
     $('.total_amount')[0].textContent = formatter.format(cartTotal);
     displayCart();
     displayProducts();
     

} );
})
.catch((error) => {
  console.error('Error:', error);
});
}

////////////////// to update product ////////////////////////////////
const updateCartDis = function(id,quantity){
	jQuery.ajax({
  url:'/cart/change.js',
  type: 'post',
  dataType: 'json',
      data: { id:id,quantity:quantity }
}).then(response => {
    jQuery.getJSON('/cart.js', function(cart) {
	cartItems = cart.items;
           let cartCount = cart.item_count;
     updateCartCount(cartCount);
      displayCart();
      displayProducts();
       let cartTotal = cart.total_price/100;
     $('.total_amount')[0].textContent = ' ';
     $('.total_amount')[0].textContent = formatter.format(cartTotal);
} );
});                

}
//to update product and not rendering products again
const updateCart = function(id,quantity){
	jQuery.ajax({
  url:'/cart/change.js',
  type: 'post',
  dataType: 'json',
      data: { id:id,quantity:quantity }
}).then(response => {
    jQuery.getJSON('/cart.js', function(cart) {
	cartItems = cart.items;
           let cartCount = cart.item_count;
     updateCartCount(cartCount);
      let cartTotal = cart.total_price/100;
     $('.total_amount')[0].textContent = ' ';
     $('.total_amount')[0].textContent = formatter.format(cartTotal);
} );
});                

}


//////////////////////////// rendering products on cart \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
const displayProducts = function(){
	$('.cart_items')[0].innerHTML = '';
  for(let product of cartItems){
  	let productId = product.variant_id;
    let productImage = product.image;
    let productTitle = product.title;
    let productPrice = formatter.format(product.price/100);
    let productQuantity = product.quantity;
     let productHtml = `<div class="aitem">
            <div class="item_img">
                <img src=" ${productImage}" />
            </div>
          <div class="item_right">
          <div class="item_info">
            <h4>${productTitle}</h4>
            <h4>${productPrice}</h4>
          </div>
          <div class="item_form">
            <form class="it_form" id="${productId}">
                <button class="dec">-</button>
					<input type="number" min="1" max="10" value="${productQuantity}"/>
                 <button class="inc">+</button>
            </form>
          </div>
          </div>
          <div class="clear_item">
			<form id="${productId}" class="clr_form">
            <button class="clr_item">
            	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
</svg>
            </button>
			</form>
          </div>
        </div>`;
    $('.cart_items')[0].insertAdjacentHTML('beforeend',productHtml);
    
    
    ////////////////////innner cart item \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
$('.inc').each(function(ind,el){
  $(el).off().on('click',function(e){
    e.preventDefault();
  	let form = $(this).closest('form');
    let prodId = form[0].id;
    let inp = $(form).children('input[type="number"]');
    let max = Number(inp[0].max);
    let inputval = Number(inp[0].value);
    if(inputval < max){
    	 inputval++;
    }else{
    	return false;
    }
   
    inp[0].value = inputval;
    updateCart(prodId,inputval);
  })
})
$('.dec').each(function(ind,el){
  $(el).off().on('click',function(e){
    e.preventDefault();
  	let form = $(this).closest('form');
    let prodId = form[0].id;
    let inp = $(form).children('input[type="number"]');
    let min = Number(inp[0].min);
    let inputval = Number(inp[0].value);
    if(inputval > min){
      console.log(min);
    	inputval--;	
      inp[0].value = inputval;
    updateCart(prodId,inputval);
    }else if(inputval === min){
	updateCartDis(prodId,0);
    }
    
  })
})

$('.clr_item').each(function(ind,el){	
  $(el).on('click',function(e){
    e.preventDefault();
  		let form = $(this).closest('form');
     let prodId = form[0].id;
    updateCartDis(prodId,0);
  })
})
  }
 
}





















///////////////////////////dawn product redirecti specified \\\\\\\\\\\\\\\\\\\\\\\\\\
// $('.product-grid .grid__item').each(function(ind,el){
//   $(el).on('click',function(e){
//   	e.preventDefault();
//   })
// })